import { formatDateToTimestamp } from '@/utils/utils'
import Service from '@/services/Service'

class AccountsService extends Service {
  constructor() {
    super('ACCOUNTS')
    this.resource = 'accounts'
  }

  translateToFirebird(obj) {
    let dataBloqueio = formatDateToTimestamp(obj.dataBloqueio)
    let objFirebird = {
      CODIGO: obj.codigo,
      CODCON: obj.codigoContabil,
      CLASSIFICACAO: obj.classificacao,
      NOME: obj.nome,
      TIPO: obj.tipo,
      CONSOLIDADA: obj.consolidada ? obj.consolidada.text : null,
      MOEDA: obj.moeda ? obj.moeda.index : null,
      APURACUSTO: obj.isApuraCusto ? obj.isApuraCusto.text : null,
      DATABLOQUEIO: dataBloqueio,
      DATACANCELAMENTO: obj.dataCancelamento,
      TAXA: obj.taxa,
      TAXA1: obj.taxa1,
      TAXA2: obj.taxa2,
      TAXA3: obj.taxa3,
      TAXA4: obj.taxa4,
      DIAS: obj.dias,
      DIAS1: obj.dias1,
      DIAS2: obj.dias2,
      DIAS3: obj.dias3,
      DIAS4: obj.dias4,
      TAXAACRFIN: obj.taxaAcrescimoFin,
      TAXAACRFIN1: obj.taxaAcrescimoFin1,
      TAXAACRFIN2: obj.taxaAcrescimoFin2,
      TAXAACRFIN3: obj.taxaAcrescimoFin3,
      TAXAACRFIN4: obj.taxaAcrescimoFin4,
      CONSOLIDAFILIAIS: obj.consolidaFiliais,
      contasUsuario: obj.contasUsuario ?? [],
      contasFilial: obj.contasFilial ?? [],
      contaDespesaCobranca: obj.contaDespesaCobranca ?? null,
    }
    // CODIGOUSUARIO: ,
    // MARCADA: ,
    // TAXAPORPARCELAS: ,
    // SALDOPARASANGRIA: ,

    return objFirebird
  }

  translateFromFirebird(obj) {
    let filiais = obj.contas_filial
      ? obj.contas_filial.map((account) => {
          return {
            CODIGO: account.pivot.CODIGO,
            NOME: account.NOME,
            FILIAL: account.FILIAL,
          }
        })
      : null

    let objeto = {
      codigo: obj.CODIGO,
      codigoContabil: obj.CODCON,
      classificacao: obj.CLASSIFICACAO,
      nome: obj.NOME,
      tipo: obj.TIPO,
      consolidada: obj.CONSOLIDADA ? { value: obj.CONSOLIDADA } : null,
      moeda: { index: parseInt(obj.MOEDA) },
      isApuraCusto: obj.APURACUSTO ? { value: obj.APURACUSTO } : null,
      dataBloqueio: obj.DATABLOQUEIO,
      dataCancelamento: obj.DATACANCELAMENTO,
      taxa: obj.TAXA,
      taxa1: obj.TAXA1,
      taxa2: obj.TAXA2,
      taxa3: obj.TAXA3,
      taxa4: obj.TAXA4,
      dias: obj.DIAS,
      dias1: obj.DIAS1,
      dias2: obj.DIAS2,
      dias3: obj.DIAS3,
      dias4: obj.DIAS4,
      taxaAcrescimoFin: obj.TAXAACRFIN,
      taxaAcrescimoFin1: obj.TAXAACRFIN1,
      taxaAcrescimoFin2: obj.TAXAACRFIN2,
      taxaAcrescimoFin3: obj.TAXAACRFIN3,
      taxaAcrescimoFin4: obj.TAXAACRFIN4,
      consolidaFiliais: obj.CONSOLIDAFILIAIS,
      contasUsuario: obj.contas_usuario ?? [],
      contasFilial: filiais ?? [],
      contaDespesaCobranca: obj.conta_despesa_cobranca ?? null,
    }
    return objeto
  }

  async createAccount(payload) {
    let requestUrl = `${this.resource}/create?CLASSIFICACAO=${encodeURIComponent(payload)}`
    let data = await this.getAPI(requestUrl)
    return this.translateFromFirebird(data)
  }

  async getAccount(id) {
    let requestUrl = `${this.resource}/${encodeURIComponent(id)}`
    let data = await this.getAPI(requestUrl)
    return this.translateFromFirebird(data)
  }

  async getAccounts(query = null) {
    if (query) {
      let requestUrl = `${this.resource}?`

      query = this.encodeQueryValues(query);

      if (query.codigo && query.codigo.length > 0) {
        requestUrl += this.hasParameter(requestUrl)
          ? `&CODIGO=${query.codigo}`
          : `CODIGO=${query.codigo}`
        // order = 'CODIGO'
      } else if (query.nome && query.nome.length > 0) {
        requestUrl += this.hasParameter(requestUrl)
          ? `&NOME=${query.nome}`
          : `NOME=${query.nome}`
        // order = 'NOME'
      } else if (query.tipo && query.tipo.length > 0) {
        requestUrl += this.hasParameter(requestUrl)
          ? `&TIPO=${query.tipo}`
          : `TIPO=${query.tipo}`
        // order = 'TIPO'
      } else if (query.classificacao && query.classificacao.length > 0) {
        requestUrl += this.hasParameter(requestUrl)
          ? `&CLASSIFICACAO=${query.classificacao}`
          : `CLASSIFICACAO=${query.classificacao}`
        // order = 'CLASSIFICACAO'
      } else if (query.hibrido && query.hibrido.length > 0) {
        // consulta pelo codigo nome classifcacao
        requestUrl += this.hasParameter(requestUrl)
          ? `&HIBRIDO=${query.hibrido}`
          : `HIBRIDO=${query.hibrido}`
      }
      
      if (query.todos)
        requestUrl += this.hasParameter(requestUrl)
          ? `&TODOS=${query.todos}`
          : `TODOS=${query.todos}`
      else
        requestUrl += this.hasParameter(requestUrl)
          ? `&page=${query.page}`
          : `page=${query.page}`

      // requestUrl += this.hasParameter(requestUrl) ? `&ORDER=${order}` : `ORDER=${order}`
      return await this.getAPI(requestUrl)
    }
  }
}

export default new AccountsService()
